import React, { useEffect, useState } from "react";
import { Users, Shield, GraduationCap, Briefcase } from "lucide-react";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import { DcddTotalUserProps } from "modules/report/dcdd_report/state/actionType";
import { fetchCommercialTotalUser } from "../state/action";
import Loading from "layout/components/Loading";

interface UserStats {
  label: string;
  count: number;
  icon: JSX.Element;
  color: string;
}
interface DcddUserDataPros {
  commercialDcddUserData: DcddTotalUserProps | null;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & DcddUserDataPros;

const StaticsData: React.FC<Props> = ({ onCommercialUserData, commercialUserDataState, commercialDcddUserData }) => {
  const [stats, setStats] = useState<UserStats[]>([]);
  useEffect(() => {
    if (!commercialDcddUserData) {
      onCommercialUserData(null, null)
    }
  }, [commercialDcddUserData])
  useEffect(() => {
    setTimeout(() => {
      const dataToShow = commercialDcddUserData || commercialUserDataState?.dcddTotalUser;
      if (!dataToShow) return;
      setStats([
        {
          label: "Total Commercial Users",
          count: dataToShow?.total_all,
          icon: <Shield className="w-8 h-8" />,
          color: "from-purple-500 to-purple-700",
        },
        {
          label: "Total Commercial Active Users",
          count: dataToShow?.total_active,
          icon: <Briefcase className="w-8 h-8" />,
          color: "from-emerald-500 to-green-600",
        },
        {
          label: "New Commercial Registered Users",
          count: dataToShow?.total_new,
          icon: <GraduationCap className="w-8 h-8" />,
          color: "from-sky-500 to-blue-600",
        },
        {
          label: "Inactive Commercial Users",
          count: dataToShow?.total_inactive,
          icon: <GraduationCap className="w-8 h-8" />,
          color: "from-red-500 to-blue-600",
        },
      ]);
    }, 1000);
  }, [commercialDcddUserData, commercialUserDataState]);

  return (
    <div className="">
      {stats.length > 0 ? (
        <div className="from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center px-6 pt-16">
          <motion.div
            className="max-w-5xl w-full"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100 mb-10 text-center flex items-center justify-center gap-2">
              <Users className="w-7 h-7 text-blue-500" />
              Commercial Users Statistics
            </h1>
            {/* Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {
                stats.map((item, index) => (
                  <motion.div
                    key={index}
                    className={`bg-gradient-to-r ${item.color} text-white rounded-2xl shadow-lg p-6 flex flex-col items-center justify-center`}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2 + index * 0.1, type: "spring" }}
                  >
                    <div className="mb-3">{item.icon}</div>
                    <p className="text-lg font-medium">{item.label}</p>
                    <h2 className="text-4xl font-extrabold mt-2">{item.count}</h2>
                  </motion.div>
                ))
              }
            </div>
            {/* Footer */}
            <motion.div
              className="mt-10 text-gray-600 dark:text-gray-400 text-center text-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
            >
              <p>
                Last updated: {new Date().toLocaleDateString()} {new Date().toLocaleTimeString()}
              </p>
            </motion.div>
          </motion.div>
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};
const mapStateToProps = (state: any) => ({
  commercialUserDataState: state.commercialTotalDataReducer.commercialTotalUsersState,
});
const mapDispatchToProps = (dispatch: any) => ({
  onCommercialUserData: (from_date: string | null, to_date: string | null) =>
    dispatch(fetchCommercialTotalUser(from_date, to_date)),
});
export default connect(mapStateToProps, mapDispatchToProps)(StaticsData);
